import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=9d2485a4&"
import script from "./ProfileSection.vue?vue&type=script&lang=ts&"
export * from "./ProfileSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=9d2485a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports